import { Injectable } from '@angular/core';
import { Driver } from '@rtls/core/models/human/driver';
import { Pagination } from '@rtls/core/models/rpc/pagination.model';
import { RtlsModels } from '@rtls/core/models/rtls/rtls-models';
import { RtlsServiceDecorator } from '@rtls/core/models/rtls/rtls-service.decorator';
import { RtlsService } from '@rtls/core/models/rtls/rtls-service.model';
import { Facet } from '@rtls/core/models/shared/filter/facet.model';
import { Observable } from 'rxjs';
import { flatMap, map, toArray } from 'rxjs/operators';

@Injectable()
export class DriverService extends RtlsServiceDecorator<Driver> {
	constructor(rtlsService: RtlsService<Driver>) {
		super(rtlsService.useModel(RtlsModels.Driver));
	}

	public all(pagination?: Pagination): Observable<Driver[]> {
		return this.getAll(pagination).pipe(map((data: any) => data.data));
	}

	public getDriversFacets(pagination?: Pagination): Observable<Facet[]> {
		return this.all(pagination).pipe(
			flatMap((drivers: Driver[]) => drivers),
			map((driver) => new Facet(driver.id, `${driver.firstName} ${driver.lastName}`)),
			toArray(),
		);
	}
}
